import { Icon20InfoCircleOutline } from '@vkontakte/icons';
import { Link, Text } from '@vkontakte/vkui';
import React, { type ReactElement, useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { enableDocumentsRecognition, loadDocumentsRecognitionStatus } from 'reactApp/modules/personalDocuments/personalDocuments.module';
import {
    getDocumentRecognitionLoadedState,
    getDocumentsRecognitionStatus,
} from 'reactApp/modules/personalDocuments/personalDocuments.selectors';
import { ERecognitionStatus } from 'reactApp/modules/personalDocuments/personalDocuments.types';
import { historyPush } from 'reactApp/modules/router/router.module';
import { sendXray } from 'reactApp/utils/ga';

import styles from './FamilyInlineInformer.css';

export const FamilyInlineInformer = (): ReactElement | null => {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(loadDocumentsRecognitionStatus());
    }, []);

    const enableRecognition = useCallback(() => {
        dispatch(enableDocumentsRecognition());
        sendXray('empty-family-docs-recognition-on');
    }, [dispatch, sendXray]);

    const textConfig: Record<string, ReactElement> = {
        enabled: (
            <>
                Файлы из этой папки также сохраняются в{' '}
                <Link onClick={() => dispatch(historyPush({ id: '/documents' }))}>Личных документах</Link>
            </>
        ),
        disabled: (
            <>
                <Link onClick={() => enableRecognition()}>Включите распознавание</Link> и храните общие документы вместе
            </>
        ),
    };

    const recognitionStatus = useSelector(getDocumentsRecognitionStatus);
    const recognitionStatusIsLoaded = useSelector(getDocumentRecognitionLoadedState);

    const [text, setText] = useState<ReactElement>(textConfig.enabled);
    useEffect(() => {
        if (recognitionStatus === ERecognitionStatus.DISABLED) {
            setText(textConfig.disabled);
        } else {
            setText(textConfig.enabled);
        }
    }, [recognitionStatus]);

    if (!recognitionStatusIsLoaded) {
        return null;
    }

    return (
        <div className={styles.root}>
            <div className={styles.icon}>
                <Icon20InfoCircleOutline />
            </div>
            <Text className={styles.text}>{text}</Text>
        </div>
    );
};

FamilyInlineInformer.displayName = 'FamilyInlineInformer';
